import React from 'react'
import { css } from '@emotion/react'
import { desktopMaxWidth, desktopMinWidth } from '../../tokens/mediaquery'
import { NoticePublishedTime } from './NoticePublishedTime'
import { Title } from './Title'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from '../../atoms/Breadcrumb'
import { colors, mq } from 'plume-ui'
import { enterpriseUrl } from '@/lib/url'

type Props = {
  title: string
  publishedAt: string
  headerImage: {
    url: string
    title: string
  }
}

export const Heading: React.FC<Props> = (props) => {
  return (
    <div
      css={css`
        padding-bottom: 130px;
        background: ${colors.brown30};
        ${mq.large} {
          padding-bottom: 340px;
        }
      `}
    >
      <Breadcrumb
        css={css`
          max-width: 1116px;
          margin: 0 auto;
          padding-top: 16px;
          ${mq.untilLarge} {
            display: none;
          }
        `}
      >
        <BreadcrumbLink href={enterpriseUrl} external>
          ホーム
        </BreadcrumbLink>
        <BreadcrumbItem>お知らせ</BreadcrumbItem>
        <BreadcrumbItem>{props.title}</BreadcrumbItem>
      </Breadcrumb>
      <div
        css={css`
          @media (max-width: ${desktopMaxWidth}) {
            margin: 0;
            padding: 16px 24px 0;
          }
          @media (min-width: ${desktopMinWidth}) {
            width: 100%;
            max-width: 730px;
            margin: 38px auto 0;
          }
        `}
      >
        <div
          css={css`
            max-width: 640px;
            margin: 0 auto;
          `}
        >
          <NoticePublishedTime publishedAt={props.publishedAt} />
          <Title text={props.title} />
        </div>
      </div>
    </div>
  )
}
